import { render, staticRenderFns } from "./relationShipNetWork.vue?vue&type=template&id=3a08bb12&scoped=true&"
import script from "./relationShipNetWork.vue?vue&type=script&lang=js&"
export * from "./relationShipNetWork.vue?vue&type=script&lang=js&"
import style0 from "./relationShipNetWork.vue?vue&type=style&index=0&id=3a08bb12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a08bb12",
  null
  
)

export default component.exports